export const workTypes = state => state.workTypes.items
export const workTypesByType = state => (type) => _.filter(state.workTypes.items, {type})
export const serviceWorkTypes = state => workTypesByType(state)('service')
export const jobWorkTypes = state => workTypesByType(state)('job')
export const workTypeById = state => id => _.find(workTypes(state), {id})
export const workTypesByIds = state => ids => _.filter(workTypes(state), item => ids.includes(item.id))
export const workTypeNameById = state => id => {
    let wt = workTypeById(state)(parseInt(id))
    return wt ? wt.title : ''
}
export const workTypeNamesByIds = (state, getters) => ids => {
    return _.reduce(ids, (res, id) => {
        let wt = getters.workTypeById(id)
        if (wt) res.push(wt.title)
        return res
    }, []).join(', ')
}